import { render, staticRenderFns } from "./Mandates.vue?vue&type=template&id=15c925ee&"
import script from "./Mandates.vue?vue&type=script&lang=js&"
export * from "./Mandates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports